<template>
  <a-modal
    v-model:visible="modalConfig.visible"
    :title="modalConfig.title"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form :model="formState" ref="formRef" :rules="rules">
      <a-form-item label="公告内容" name="translDeptNotice">
        <a-input
          v-model:value="formState.translDeptNotice"
          placeholder="请输入公告内容"
        ></a-input>
      </a-form-item>

      <a-form-item label="接收部门" name="translDept">
        <a-select
          :options="departmentOptions"
          v-model:value="formState.translDept"
          placeholder="请选接收部门"
        >
        </a-select>
      </a-form-item>

      <a-form-item label="文件" name="fileLink">
        <upload
          :echoFile="formState.fileLink"
          @setUploadFileUrl="setDeliveryFile"
          :action="uploadTransDeptFile"
        >
        </upload>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
   
<script>
import { defineComponent, reactive, ref } from "vue";
import { useStore } from "vuex";
import {
  saveTransDeptNotice,
  uploadTransDeptFile,
} from "@/request/view/transDept";

import selectDepartment from "@/views/departmentalRequirements/components/selectDepartment.vue";
import upload from "@/views/rdmanagement/components/database/upload.vue";
import { Toast } from "@/utils";

import { getDepartmentOptions } from "@/views/transDepartment/departmentAnnouncement/options";

export default defineComponent({
  components: {
    upload,
    selectDepartment,
  },
  setup(props, context) {
    const store = useStore();
    const user = store.state.user.user;

    const departmentOptions = getDepartmentOptions();
    const modalConfig = reactive({
      visible: false,
      title: null,
    });

    const formState = reactive({
      createTime: null,
      fileLink: null,
      id: null,
      originalDept: null,
      translDept: null,
      translDeptNotice: null,
      userId: null,
      username: null,
    });

    const rules = {
      translDeptNotice: [
        {
          required: true,
          message: "请输入公告内容",
          trigger: "blur",
          type: "string",
        },
      ],
      translDept: [
        {
          required: true,
          message: "请选择跨接收部门",
          trigger: "blur",
          type: "string",
        },
      ],
    };

    // 选择通知部门
    const handleSelectDepartment = (department) => {
      formState.translDept = department;
    };

    const setDeliveryFile = (url) => {
      formState.fileLink = url;
    };

    const formRef = ref();

    const resetForm = () => {
      Object.keys(formState).forEach((key) => {
        formState[key] = null;
      });
      formRef.value.clearValidate();
    };

    const handleCancel = () => {
      resetForm();
      modalConfig.title = null;
      modalConfig.visible = false;
    };

    const showModal = (type, options) => {
      const { title, data } = options;

      if (type === "update") {
        Object.keys(formState).forEach((key) => {
          formState[key] = data[key];
        });
      }

      if (type === "insert") {
        formState.originalDept =
          user.firstLevelDepartment || user.secondaryDepartment;

        formState.userId = user.id;
        formState.username = user.nickName;
      }

      modalConfig.title = title;
      modalConfig.visible = true;
    };

    const handleOk = () => {
      formRef.value
        .validateFields()
        .then((res) => {
          saveTransDeptNotice(formState).then((res) => {
            const type = res.code === 200 ? "success" : "warning";
            Toast(type, res.message, 3);
            handleCancel();
            context.emit("handleUpdateTable");
          });
        })
        .catch((err) => {
          if (err && err.errorFields) {
            const [errText] = err.errorFields[0].errors;
            Toast("warning", errText, 3);
          }
        });
    };

    return {
      modalConfig,
      handleOk,
      handleCancel,
      showModal,
      handleSelectDepartment,
      uploadTransDeptFile,
      setDeliveryFile,
      departmentOptions,
      formState,
      formRef,
      rules,
    };
  },
});
</script>
   
<style lang="less" scoped>
</style>